import { useFormContext } from "@/context/FormContext";
import Constants from "@/static/constants/constants.json";

// statuses that disable vendor forms/fields
const vendorDisabledStatuses = [
  Constants.ARCHIVED_STATUS?.toLowerCase?.(),
  Constants.ON_HOLD_STATUS?.toLowerCase?.(),
  Constants.HOLD_STATUS?.toLowerCase?.()
].filter(Boolean) as string[];

export type UseFormDisabledOptions = {
  vendorId?: number | string;
};

export function useFormDisabled(options?: UseFormDisabledOptions) {
  const { statusesOfVendorObj } = useFormContext();

  // Prefer explicit vendorId; otherwise infer if there is exactly one vendor in the object
  let vendorId = options?.vendorId;
  if ((vendorId === undefined || vendorId === null) && statusesOfVendorObj) {
    const vendorKeys = Object.keys(statusesOfVendorObj as any);
    if (vendorKeys.length === 1) {
      vendorId = vendorKeys[0];
    }
  }
  let isDisabled = false;

  if (vendorId !== undefined && vendorId !== null) {
    const keyString = String(vendorId);
    const keyNumber = Number.isNaN(Number(vendorId)) ? undefined : Number(vendorId);
    const vendorObj =
      (statusesOfVendorObj as any)?.[keyString] ??
      (keyNumber !== undefined ? (statusesOfVendorObj as any)?.[keyNumber] : undefined);
    const vendorStatus = vendorObj?.status?.toLowerCase?.();
    if (typeof vendorStatus === "string" && vendorStatus.length > 0) {
      isDisabled = vendorDisabledStatuses.includes(vendorStatus);
    } else {
      // if vendor status unknown for the provided vendorId, default to not disabled
      isDisabled = false;
    }
  } else {
    // if vendorId is not provided, default to not disabled
    isDisabled = false;
  }

  const isFieldDisabled = (_fieldName?: string) => isDisabled;

  return { isDisabled, isFieldDisabled };
}

export default useFormDisabled;


